import { useRef, useState } from "react";

import { useTranslation } from "@impero-com/common/utils/i18n";
import { TSTTable } from "@impero-com/ui";
import { OnChangeFn, RowSelectionState } from "@tanstack/react-table";

import { EntityListLinkedResources, EntityOverview } from "api/generated/model";
import { DebouncedSearchInput } from "components/DebouncedSearchInput";

import * as theme from "./ControlEntitiesTables.css";
import { useAddEntitiesTable } from "./useAddEntitiesTable";

interface SelectEntitiesTableProps {
    linkedResources: EntityListLinkedResources;
    controlEntities: EntityOverview[];
    selectedRows: { [key: string]: boolean };
    onSelectedRowsChange: OnChangeFn<RowSelectionState>;
}

export function SelectEntitiesTable({
    linkedResources,
    controlEntities,
    selectedRows,
    onSelectedRowsChange,
}: SelectEntitiesTableProps) {
    const { t } = useTranslation();
    const [globalFilter, setGlobalFilter] = useState("");
    const table = useAddEntitiesTable({
        linkedResources,
        controlEntities,
        onSelectedRowsChange,
        selectedRows,
        globalFilter,
        setGlobalFilter,
    });

    const tableRef = useRef<HTMLDivElement>(null);

    return (
        <div>
            <div className={theme.tableFilter}>
                <DebouncedSearchInput
                    globalSearchLabel={t("FilterBar_GlobalSearchPlaceholder")}
                    onGlobalSearchChange={setGlobalFilter}
                    getGlobalSearchValue={() => globalFilter}
                    className={theme.searchInput}
                />
            </div>
            <TSTTable
                tableRef={tableRef}
                table={table}
                noResultsFallback={t("NoResults")}
                noSourceRowsFallback={t("NoResults")}
            />
        </div>
    );
}
